import Book1 from '../components/Book1';
import WritingHero from '../components/WritingHero';

function Writing() {
  return (
    <main>
      <WritingHero />
      <section className='writing-page container-large'>
        <div className='writing-panel'>
          <div className='writing-panel__header'>
            <p className='writing-panel__eyebrow'>Library</p>
            <h2>Writing and works</h2>
            <p className='writing-panel__intro animate-text'>
              Schuyler&apos;s fiction draws on a career in broadcasting, public
              affairs, and speech writing. That background gives the work a
              clear narrative voice, while his return to faith shapes stories
              centered on exile, belonging, and spiritual discovery.
            </p>
          </div>
          <div className='writing-panel__highlights'>
            <div className='writing-panel__highlight'>
              <span className='writing-panel__highlight-label'>Voice</span>
              <span>Journalistic clarity with an intimate narrative tone</span>
            </div>
            <div className='writing-panel__highlight'>
              <span className='writing-panel__highlight-label'>Themes</span>
              <span>Faith, displacement, courage, and redemption</span>
            </div>
            <div className='writing-panel__highlight'>
              <span className='writing-panel__highlight-label'>Focus</span>
              <span>Stories rooted in biblical history and lived emotion</span>
            </div>
          </div>
          <Book1 />
        </div>
      </section>
    </main>
  );
}

export default Writing;
